<div>
  <h2 class="title is-3 mb-5 is-underlined has-text-link pointer">
    <a routerLink="/catalogue/metric-use-cases/{{ metricUseCase.slug }}">
      {{ metricUseCase.name | stripHtml }}
    </a>
  </h2>
  <span class="icon-text tool-relations">
    <ng-container *ngIf="metricUseCase.purposes?.length">
      <span class="icon">
        <i class="icon icon-Select is-size-7 has-text-primary"></i>
      </span>

      <span
        class="country-label sans content is-small"
        *ngFor="let purpose of metricUseCase.purposes"
        >{{ purpose.name }}</span
      >
    </ng-container>
    <span class="icon">
      <i class="icon icon-Calendar is-size-7 has-text-primary"></i>
    </span>
    <span class="my-0 country-label sans content is-small"
      >Uploaded on {{ metricUseCase.publishedAt | date }}</span
    >
  </span>

  <div>
    <div [innerHTML]="metricUseCase.content | truncate : [180]"></div>
  </div>
  <div class="columns">
    <div
      class="column is-5"
      *ngIf="metricUseCase.objectives && metricUseCase.objectives.length"
    >
      <!-- Tags -->
      <p class="is-size-6 mt-0 is-bold mb-4">Objective(s)</p>

      <div class="tags">
        <a
          class="tag m-r-xs m-b-xs has-text-danger pointer objective-link"
          *ngFor="let objective of metricUseCase.objectives"
          [routerLink]="['/catalogue/metric-use-cases']"
          [queryParams]="{ objectiveIds: objective.id }"
          title="See Metric use cases for &quot;{{ objective.name }}&quot;"
          >{{ objective.name }}</a
        >
      </div>
    </div>
  </div>
  <hr class="is-large my-6 has-background-white-bis" />
</div>
